import React, { useState } from "react";
import styles from "./ClientForm.module.css";
import WelcomeScreen from "./WelcomeScreen"; // ✅ import the welcome screen

function SummarySubmit({ formData, prevStep }) {
  const [submitting, setSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = async () => {
    setSubmitting(true);

    try {
      // ✅ Transform liabilities into objects (keeps structured for Zapier)
      const transformedLiabilities = (formData.liabilities || []).map((l) => ({
        type: l.type || "",
        balance: l.balance || "",
        limit: l.limit || "",
        repayment: l.repayment || "",
      }));

      const payload = {
        ...formData,
        liabilities: transformedLiabilities,
      };

      console.log("Sending payload to Zapier:", payload);

      await fetch("https://hooks.zapier.com/hooks/catch/17916584/umztw62/", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
        mode: "no-cors",
      });

      setSubmitted(true);
      localStorage.removeItem("clientAppData");
    } catch (err) {
      console.error("❌ Submit error:", err);
      alert("❌ Something went wrong submitting your details. Please try again.");
    }

    setSubmitting(false);
  };

  // ✅ Show WelcomeScreen with applicant’s name after successful submit
  if (submitted) {
    return <WelcomeScreen formData={formData} />;
  }

  return (
    <div className={styles.container}>
      <h3>Submit Application</h3>
      <p>Click the button below to send your details securely to Mortgage Matrix.</p>

      <div className={styles.navBtns}>
        <button onClick={prevStep}>← Back</button>
        <button
          className={styles.nextBtn}
          onClick={handleSubmit}
          disabled={submitting}
        >
          {submitting ? "Submitting..." : "Submit Application"}
        </button>
      </div>
    </div>
  );
}

export default SummarySubmit;
